import styled from 'styled-components';

export const TowerSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  margin-top: 1.5rem;
`;

export const TowerNameInput = styled.div`
  display: flex;
  align-items: flex-end;
  column-gap: 1rem;
  max-width: 28.625rem;

  & > div {
    min-width: 16.875rem;
  }

  & > button {
    min-width: 10.75rem;
  }
`;
